<template>
  <div class="persona_center">
    <div class="m">
      <!-- 侧边栏 -->
      <div class="side_box">
        <!-- 个人信息 -->
        <div class="info_card">
          <img class="avater" :src="(info && info.headPath) || avater" />
          <div class="my_name" v-if="info">{{info.user_name}}</div>
          <div class="lab" v-if="designer && designer.status ==='IdentityCertifieStatussuccess'">
            <span v-if="designer">{{designer.school_name || designer.name}}</span>
            <span class="syb">|</span>

            <span>{{info.role_name}}</span>
          </div>
          <template v-else>未认证</template>
        </div>
        <!-- 菜单 -->
        <ul class="side_nav">
          <li :class="{active:$route.meta.exp ==='个人主页'}">
            <router-link class="bdb" to="/personal_center/homepage">个人主页</router-link>
          </li>
          <li :class="{active:$route.meta.exp.indexOf('个人主页-我是评委')>-1}">
            <router-link class="bdb" to="/personal_center/i_am_judge">我是评委</router-link>
          </li>
          <li :class="{active:$route.meta.exp.indexOf('个人主页-关注的人')>-1}">
            <router-link class="bdb" to="/personal_center/homepage_care">我的关注</router-link>
          </li>
          <li :class="{active:$route.meta.exp.indexOf('个人主页-赞过')>-1}">
            <router-link class="bdb" to="/personal_center/homepage_like">我的点赞</router-link>
          </li>
          <!-- <li :class="{active:$route.meta.exp==='我的任务'}">
            <router-link to="/personal_center/task">我的任务</router-link>
          </li>
          <li :class="{active:$route.meta.exp==='我的作品'}">
            <router-link to="/personal_center/works">我的作品</router-link>
          </li>
          <li :class="{active:$route.meta.exp==='我的课程'}">
            <router-link to="/personal_center/course">我的课程</router-link>
          </li>
          <li :class="{active:$route.meta.exp.indexOf('我的经验值')>-1}">
            <router-link to="/personal_center/experience">我的经验值</router-link>
          </li>-->
          <li class="bdb" :class="{active:$route.meta.exp==='账号信息'}">
            <router-link to="/personal_center/account">基本资料</router-link>
          </li>
          <li :class="{active:$route.meta.exp.indexOf('账号安全')>-1}">
            <router-link class="bdb" to="/personal_center/safe">账号安全</router-link>
          </li>
          <!--          <li :class="{active:$route.meta.exp==='消息通知'}">-->
          <!--            <router-link to="/personal_center/notify">-->
          <!--              消息通知-->
          <!--              <el-badge :value="12"></el-badge>-->
          <!--            </router-link>-->
          <!--          </li>-->
        </ul>
      </div>
      <!-- 内容区域 -->
      <div class="main_box">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.scss";
import avater from "@/assets/img/common/avater.png";
export default {
  data() {
    return {
      avater: avater
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    },
    loginVisible() {
      return this.$store.state.isLoginDialog;
    }
  },
  created() {},
  methods: {
    /* 监测个人信息 */
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    go(name) {
      let code = this.designer ? this.designer.code : "";
      this.$router.push({
        name: name,
        query: {
          code: code
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.persona_center {
  padding: 30px 0 50px;
  background: #f5f5f5;
  .m {
    display: flex;
  }
  .side_box {
    width: 308px;
    .info_card {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 0;
      box-sizing: border-box;
      background: #fff;
      .my_name {
        font-size: 16px;
        color: #333;
        padding: 20px 0 14px;
      }
      .avater {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .name {
        display: flex;
        align-items: center;
        height: 30px;
        font-size: 16px;
        color: $font-black;
        margin-top: 13px;
        .nick_name {
          white-space: nowrap;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .lbl_lv {
        padding: 0 5px;
        height: 16px;
        line-height: 16px;
        background: #cfbb87;
        font-size: 12px;
        color: #fff;
        margin-left: 8px;
      }
      .lab {
        display: flex;
        align-items: center;
        height: 27px;
        color: $font-gary;
        font-size: 13px;
        .syb {
          padding: 0 10px;
        }
        .remark {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .btns {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 190px;
        margin-top: 14px;
        button {
          width: 100%;
        }
        button + button {
          margin-top: 10px;
        }
        .youling {
          background: #fff;
          border: 1px solid $bd-color;
          color: $font-gary;
        }
      }
    }
    .side_nav {
      background: #fff;
      margin-top: 10px;
      li {
        padding: 0 30px;
        position: relative;
        a {
          font-size: 14px;
          color: $font-black;
          display: block;
          height: 49px;
          line-height: 49px;
          display: flex;
          justify-content: space-between;
        }
        &:hover {
          background: #f5f5f5;
        }
      }
      li.active::after {
        content: "";
        width: 3px;
        height: 22px;
        background: #111;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -11px;
        cursor: pointer;
      }
    }
  }
  .main_box {
    width: 862px;
    margin-left: 30px;
  }
  .bdb {
    border-bottom: 1px solid $bd-color;
  }
}
</style>
